import axios from "axios";

// systemAdmin-only: drive the survey-report answers backfill.
const start = () => axios.post("api/v1/admin/survey-reports/backfill/start");
const stop = () => axios.post("api/v1/admin/survey-reports/backfill/stop");
const getStatus = () => axios.get("api/v1/admin/survey-reports/backfill/status");

const ApiSurveyReportBackfill = { start, stop, getStatus };

export default ApiSurveyReportBackfill;
